import React from 'react';
import styled from 'styled-components';
import infinity from "../../icons/infinity.svg";
import barbell from "../../icons/barbell.svg";
import settings from "../../icons/settings.svg";

const ModeCardContainer = styled.div`
    background-color: white;
    /* width: 20vw; */
    flex: 1;
    height: 38vh;
    border-radius: 40px;
    box-shadow: #0000001c 0 0 20px 10px;
    margin: 3vh;
    align-items: center;
    @media only screen 
		and (orientation: portrait)
        and (max-width: 400px) {
            display: flex;
            flex-direction: row;
            height: 50vw;
            flex: unset;
	}
`

const ModeDescriptionContainer = styled.div`
    @media only screen 
		and (orientation: portrait)
        and (max-width: 400px) {
            flex: 3;
            display: flex;
            flex-direction: column;
            justify-content: center;
	}
`

const ModeLogo = styled.div`
    width: 90%;
    height: 10vh;
    background-position: ${({ position }) => position || 'center center'};
    background-repeat: no-repeat;
    background-size: ${({ size }) => size || '13vh'};;
    padding: 5%;
    background-image: url(${({ src }) => src});
    @media only screen 
		and (orientation: portrait)
        and (max-width: 400px) {
            flex: 1;
            background-size: 20vw;
	}
`

const ModeTitle = styled.div`
    font-size: 5vh;
    font-family: 'Raleway', sans-serif;
    color: black;
    width: 100%;
    text-align: center;
`

const FeaturesList = styled.div`
    margin-top: 2vh;
`

const FeaturesElement = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1vh;
`

const FeaturesIcon = styled.div`

`

const FeaturesText = styled.div`
    font-size: 2.3vh;
    font-family: 'Raleway', sans-serif;
    @media only screen 
		and (orientation: portrait)
        and (max-width: 400px) {
            font-size: 4.5vw;
	}
`


const ModeCard = ({ mode, onClick }) => {

    let logo, position, title, size, features;
    switch (mode) {
        case 'infinite':
            logo = infinity; 
            position = 'center 4.7vh'; 
            title = 'Infinite';
            break;
        case 'training':
            logo = barbell;
            title = 'Training'; 
            break;
        case 'custom':
            logo = settings; 
            title = 'Custom'; 
            size= '9vh'; 
            break;
        default:
            logo = infinity; 
            title = 'Infinite'; break;
    }

    return (
        <ModeCardContainer onClick={onClick}>
            <ModeLogo src={logo} position={position} size={size} />
            <ModeDescriptionContainer>
                <ModeTitle>
                    {title}
                </ModeTitle>
                {
                    mode === 'infinite' &&
                        <FeaturesList>
                            <FeaturesElement>
                                <FeaturesIcon></FeaturesIcon>
                                <FeaturesText>Nekonečné cvičení</FeaturesText>
                            </FeaturesElement>
                            <FeaturesElement>
                                <FeaturesIcon></FeaturesIcon>
                                <FeaturesText>Žádné časové omezení</FeaturesText>
                            </FeaturesElement>
                            <FeaturesElement>
                                <FeaturesIcon></FeaturesIcon>
                                <FeaturesText>Žádný leaderboard</FeaturesText>
                            </FeaturesElement>
                        </FeaturesList>
                }
                {
                    mode === 'training' &&
                        <FeaturesList>
                            <FeaturesElement>
                                <FeaturesIcon></FeaturesIcon>
                                <FeaturesText>20 cvičení na hru</FeaturesText>
                            </FeaturesElement>
                            <FeaturesElement>
                                <FeaturesIcon></FeaturesIcon>
                                <FeaturesText>10-20 sekund na odpověď</FeaturesText>
                            </FeaturesElement>
                            <FeaturesElement>
                                <FeaturesIcon></FeaturesIcon>
                                <FeaturesText>Globální leaderboard</FeaturesText>
                            </FeaturesElement>
                        </FeaturesList>
                }
            </ModeDescriptionContainer>
        </ModeCardContainer>
    );
};

export default ModeCard;